export default function roundOff(val, decimal = 8) {
   let pow = Math.pow(10, decimal);

    return Math.floor(val * pow) / pow;

};
